/**
 * isInViewport
 *
 * Only plays videos that are with in the viewport.
 *
 * https://github.com/zeusdeux/isInViewport
 */
export default function initInView() {
    window.addEventListener('scroll', function () {
        inviewvideo();
    });

    function inviewvideo() {
        jQuery('video').each(function () {
            if (jQuery(this).is(":in-viewport")) {
                jQuery(this)[0].play();
            } else {
                jQuery(this)[0].pause();
            }
        });
    }
    inviewvideo();
}